import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { ReservationType } from 'src/features/reservations/types/reservationType';

const RESOURCE = 'reservations/:parkingId/vehicle-stay-reservation-type/:versionId/';

interface DTO {
    parkingId: string;
    versionId: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ versionId, parkingId }: DTO): Promise<ReservationType> => {
    return axios.delete(formatResourcePath(RESOURCE, { versionId, parkingId }));
};

interface UseMutationOptions extends MutationConfig<MutationFnType> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteReservationType };
export type { DTO as DeleteReservationTypeDTO };
